import React from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Psychic, 
  Force,
  Poison,
  Acid,
  Radiant,
  Cold,
  Fire,
  Lightning,
  Thunder,
  Healing,
  Necrotic,
  Bludgeoning,
  Piercing,
  Slashing
} from "@models/Images";

export default function Attributions() {

  const imgStyle: React.CSSProperties = {
    width: "5em",
    height: "5em",
    border: "1px solid blue",
    backgroundColor: "white"
  };
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 6
        }}>
        <img src={Psychic} alt="Psychic" 
          style={imgStyle} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        Brain by Minh Do from the Noun Project
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <img src={Force} alt="Force" 
          style={imgStyle} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
       meteor by Colourcreatype from the Noun Project
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <img src={Poison} alt="Poison" 
          style={imgStyle} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        Poison by Diego Naive from the Noun Project
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <img src={Acid} alt="Acid" 
          style={imgStyle} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        Poison by Luis Prado from the Noun Project
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <img src={Radiant} alt="Radiant" 
          style={imgStyle} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        sun by Alice Design from the Noun Project
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <img src={Cold} alt="Cold" 
          style={imgStyle} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        Cold by Landan Lloyd from the Noun Project
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <img src={Fire} alt="Fire" 
          style={imgStyle} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        Fire by Aisyah from the Noun Project
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <img src={Lightning} alt="Lightning" 
          style={imgStyle} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        Lightning by Locad from the Noun Project
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <img src={Thunder} alt="Thunder" 
          style={imgStyle} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        thunder by LUTFI GANI AL ACHMAD from the Noun Project
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <img src={Healing} alt="Healing" 
          style={imgStyle} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        Heart by Bluetip Design from the Noun Project
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <img src={Necrotic} alt="Necrotic" 
          style={imgStyle} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        grim reaper by Baboon designs from the Noun Project
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <img src={Bludgeoning} alt="Bludgeoning" 
          style={imgStyle} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        hit by Guilherme Furtado from the Noun Project
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <img src={Piercing} alt="Piercing" 
          style={imgStyle} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        hit by P Thanga Vignesh from the Noun Project
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <img src={Slashing} alt="Slashing" 
          style={imgStyle} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        By Carter Precourt 
      </Grid>
    </Grid>
  );
}
